import { Modal, ModalBody, ModalHeader, Text, VFlow } from 'bold-ui'
import { ReactNode } from 'react'

export interface CidadaoObitoModalProps {
  isModalOpen: boolean
  onClose(): void
}

const MODAL_TITLE: ReactNode = (
  <>
    Cidadão veio a óbito, reconduza o<br /> cuidado para finalizá-lo.
  </>
)

export const CidadaoObitoModal = (props: CidadaoObitoModalProps) => {
  const { onClose, isModalOpen } = props

  return (
    <Modal open={isModalOpen} size='auto' onClose={onClose} closeOnBackdropClick>
      <ModalHeader title={MODAL_TITLE} icon={{ name: 'exclamationTriangleOutline', fill: 'alert' }} />
      <ModalBody>
        <VFlow vSpacing={0}>
          <div style={{ marginLeft: '4rem' }}>
            <Text>
              Este cuidado compartilhado será finalizado automaticamente quando o<br /> cuidado for reconduzido ao
              solicitante. Acesse a tela de discussão de caso
              <br /> para reconduzir o cuidado.
            </Text>
          </div>
        </VFlow>
      </ModalBody>
    </Modal>
  )
}
